import React from "react";
import "./Clients.css";

export default function Clients() {
  return (
    <div className="clients-container">
      <div className="clients-header slide-in-right">
        <h3>the clients..</h3>
      </div>
      <div className="clients-content slide-in-left">
        <a target="_blank"
          rel="noopener noreferrer"href="https://ejikethegreat.com/"><img src="/ejikelogo.png" alt="ej-icon" /></a>

        <a target="_blank"
          rel="noopener noreferrer" href="https://www.burgersandbottles.com/"><img src="/burgersandbottlesLogo.png" alt="b&b-icon" /></a>

        <a target="_blank"
          rel="noopener noreferrer" href="https://esea.pro/"><img src="/eseaLogo.png" alt="esea-icon" /></a>

        </div>
    </div>
  );
}
